/* ============================================================
   Walls Republic — Header + Mega Menu behavior (vanilla JS)
   Markup: snippets/main-nav.liquid | Styles: assets/mega-menu.css

   Desktop (>=993px): hover-intent opens panels, Escape/focus-out closes.
   Mobile  (<=992px): hamburger opens the drawer, tapping an item
   drills into its panel, back arrow returns. Same DOM both ways.
   ============================================================ */
(function () {
  'use strict';

  var nav = document.getElementById('main-nav');
  if (!nav) return;

  var desktop = window.matchMedia('(min-width: 993px)');
  var overlay = document.querySelector('.nav-overlay');
  var hamburger = document.querySelector('.js-menu-toggle');
  var items = Array.prototype.slice.call(nav.querySelectorAll('.menu-item.has-mega'));
  var openTimer = null;
  var closeTimer = null;

  function setExpanded(li, expanded) {
    var toggle = li.querySelector('.menu-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openItem(li) {
    items.forEach(function (other) {
      if (other !== li) {
        other.classList.remove('is-open');
        setExpanded(other, false);
      }
    });
    li.classList.add('is-open');
    setExpanded(li, true);
  }

  function closeAll() {
    items.forEach(function (li) {
      li.classList.remove('is-open');
      setExpanded(li, false);
    });
  }

  function openDrawer() {
    document.body.classList.add('nav-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    document.body.classList.remove('nav-open');
    closeAll();
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }

  /* ----- desktop hover intent ----- */
  items.forEach(function (li) {
    li.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openItem(li); }, 80);
    });
    li.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        li.classList.remove('is-open');
        setExpanded(li, false);
      }, 120);
    });

    /* chevron button: keyboard toggle on desktop, drill-in on mobile */
    var toggle = li.querySelector('.menu-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (li.classList.contains('is-open') && desktop.matches) {
          li.classList.remove('is-open');
          setExpanded(li, false);
        } else {
          openItem(li);
        }
      });
    }

    /* mobile: tapping the top-level label drills in instead of navigating */
    var topLink = li.querySelector('.menu-top-link');
    if (topLink) {
      topLink.addEventListener('click', function (event) {
        if (desktop.matches) return;
        event.preventDefault();
        openItem(li);
      });
    }

    var back = li.querySelector('.panel-back');
    if (back) {
      back.addEventListener('click', function () {
        li.classList.remove('is-open');
        setExpanded(li, false);
      });
    }
  });

  /* close open panel when keyboard focus leaves it (desktop) */
  nav.addEventListener('focusout', function (event) {
    if (!desktop.matches) return;
    if (!nav.contains(event.relatedTarget)) closeAll();
  });

  /* ----- hamburger / overlay / close button ----- */
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (document.body.classList.contains('nav-open')) closeDrawer();
      else openDrawer();
    });
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  var drawerClose = nav.querySelector('.nav-drawer-close');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (document.body.classList.contains('nav-open')) {
      closeDrawer();
      if (hamburger) hamburger.focus();
    } else {
      closeAll();
    }
  });

  /* reset state when crossing the breakpoint */
  var onBreakpointChange = function () {
    closeDrawer();
  };
  if (desktop.addEventListener) desktop.addEventListener('change', onBreakpointChange);
  else desktop.addListener(onBreakpointChange); /* older Safari */

  /* ----- sticky nav (desktop): fixed + placeholder, same as the old bar ----- */
  var placeholder = document.createElement('div');
  placeholder.className = 'site-nav-placeholder';
  placeholder.style.display = 'none';
  nav.parentNode.insertBefore(placeholder, nav);

  var navTop = 0;
  var ticking = false;

  function measure() {
    var wasStuck = nav.classList.contains('is-stuck');
    if (wasStuck) {
      nav.classList.remove('is-stuck');
      placeholder.style.display = 'none';
    }
    navTop = nav.getBoundingClientRect().top + window.pageYOffset;
    if (wasStuck) updateSticky();
  }

  function updateSticky() {
    if (!desktop.matches) {
      nav.classList.remove('is-stuck');
      placeholder.style.display = 'none';
      return;
    }
    if (window.pageYOffset > navTop) {
      if (!nav.classList.contains('is-stuck')) {
        placeholder.style.height = nav.offsetHeight + 'px';
        placeholder.style.display = 'block';
        nav.classList.add('is-stuck');
      }
    } else {
      nav.classList.remove('is-stuck');
      placeholder.style.display = 'none';
    }
  }

  /* ----- sticky search (mobile): same fixed + placeholder trick for the
     header search bar, so it stays reachable while scrolling ----- */
  var mobileSearch = document.querySelector('header .mobile-header-search');
  var searchPlaceholder = null;
  var searchTop = 0;

  if (mobileSearch) {
    searchPlaceholder = document.createElement('div');
    searchPlaceholder.style.display = 'none';
    mobileSearch.parentNode.insertBefore(searchPlaceholder, mobileSearch);
  }

  function measureSearch() {
    if (!mobileSearch) return;
    var wasStuck = mobileSearch.classList.contains('is-stuck');
    if (wasStuck) {
      mobileSearch.classList.remove('is-stuck');
      searchPlaceholder.style.display = 'none';
    }
    searchTop = mobileSearch.getBoundingClientRect().top + window.pageYOffset;
    if (wasStuck) updateSearchSticky();
  }

  function updateSearchSticky() {
    if (!mobileSearch) return;
    /* desktop, or the bar is display:none at this width */
    if (desktop.matches || mobileSearch.offsetWidth === 0) {
      mobileSearch.classList.remove('is-stuck');
      searchPlaceholder.style.display = 'none';
      return;
    }
    if (window.pageYOffset > searchTop) {
      if (!mobileSearch.classList.contains('is-stuck')) {
        searchPlaceholder.style.height = mobileSearch.offsetHeight + 'px';
        searchPlaceholder.style.display = 'block';
        mobileSearch.classList.add('is-stuck');
      }
    } else {
      mobileSearch.classList.remove('is-stuck');
      searchPlaceholder.style.display = 'none';
    }
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateSticky();
      updateSearchSticky();
      ticking = false;
    });
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      measure();
      updateSticky();
      measureSearch();
      updateSearchSticky();
      ticking = false;
    });
  });

  measure();
  updateSticky();
  measureSearch();
  updateSearchSticky();
})();
